export default "__VITE_ASSET__BgftMfbF__"